module.exports = __webpack_public_path__ + "img/jumbotron.99724cb4.jpg";